import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

import translations from './ConditionGuidance.translations'

export const GRADE_TO_GALLERY: Record<
  number,
  Array<{ src: string; alt: I18nDefinition }>
> = {
  10: [
    {
      src: '/img/product/funnel/smartphone_10_1',
      alt: translations.excellent1,
    },
    {
      src: '/img/product/funnel/smartphone_10_2',
      alt: translations.excellent3,
    },
    {
      src: '/img/product/funnel/smartphone_10_3',
      alt: translations.excellent2,
    },
  ],
  11: [
    {
      src: '/img/product/funnel/smartphone_11_1',
      alt: translations.good1,
    },
    {
      src: '/img/product/funnel/smartphone_11_2',
      alt: translations.good3,
    },
    {
      src: '/img/product/funnel/smartphone_11_3',
      alt: translations.good2,
    },
  ],
  12: [
    {
      src: '/img/product/funnel/smartphone_12_1',
      alt: translations.fair1,
    },
    {
      src: '/img/product/funnel/smartphone_12_2',
      alt: translations.fair3,
    },
    {
      src: '/img/product/funnel/smartphone_12_3',
      alt: translations.fair2,
    },
  ],
}
